import moment from 'moment'

export function formatDate(date, formatTemplate = 'YYYY-MM-DD HH:mm:ss') {
  return date ? moment(date).format(formatTemplate) : 'N/A'
}

// 脱敏邮箱
export function maskEmail(email) {
  if (!email) return
  var pattern = /^(.{3})(.*)(@.*)$/
  var match = email.match(pattern)

  if (match) {
    var username = match[1]
    var domain = match[3]

    var maskedMiddleChars = '****'

    var maskedEmail = username + maskedMiddleChars + domain
    return maskedEmail
  } else {
    return email
  }
}

// 脱敏手机号
export function maskPhoneNumber(phoneNumber) {
  if (!phoneNumber) return
  var pattern = /^(.{3})(.*)(.{4})$/
  var match = phoneNumber.match(pattern)

  if (match) {
    var firstTwoDigits = match[1]
    var lastTwoDigits = match[3]

    var maskedMiddleDigits = '****'

    var maskedPhoneNumber = firstTwoDigits + maskedMiddleDigits + lastTwoDigits
    return maskedPhoneNumber
  } else {
    return phoneNumber
  }
}

const SYNCED_LAST_NAME_KEY = 'basicUserNameSynced'

export function saveSyncedLastName(userId, lastName) {
  if (userId == null || userId === '' || !lastName) return
  sessionStorage.setItem(SYNCED_LAST_NAME_KEY, JSON.stringify({ userId, lastName }))
}

export function readSyncedLastName(userId) {
  if (userId == null || userId === '') return ''
  const raw = sessionStorage.getItem(SYNCED_LAST_NAME_KEY)
  if (!raw) return ''
  try {
    const parsed = JSON.parse(raw)
    if (parsed && String(parsed.userId) === String(userId) && parsed.lastName) {
      return parsed.lastName
    }
  } catch (e) {}
  return ''
}

export function clearSyncedLastName(userId) {
  if (userId == null || userId === '') return
  const raw = sessionStorage.getItem(SYNCED_LAST_NAME_KEY)
  if (!raw) return
  try {
    const parsed = JSON.parse(raw)
    if (parsed && String(parsed.userId) === String(userId)) {
      sessionStorage.removeItem(SYNCED_LAST_NAME_KEY)
    }
  } catch (e) {}
}

// 可用余额向下取到分。1e-8 只抵消 10.1*100 这类浮点误差，不会把不足 1 分抬上去。
export function spendableCents(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || n <= 0) return 0
  return Math.floor(n * 100 + 1e-8)
}

export function isInWebView() {
  return localStorage.getItem('isWebView') === '1'
}

export function getBrowserInfo() {
  const userAgent = navigator.userAgent

  // 判断浏览器类型和版本
  let browser = 'Unknown'

  if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edge') === -1) {
    browser = 'Chrome'
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    browser = 'Safari'
  } else if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox'
  } else if (userAgent.indexOf('Edge') > -1) {
    browser = 'Edge'
  } else if (userAgent.indexOf('Trident') > -1) {
    browser = 'Internet Explorer'
  } else if (userAgent.indexOf('MSIE') > -1) {
    browser = 'Internet Explorer'
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    browser = 'Opera'
  }

  return browser
}



// WEBPACK FOOTER //
// ./src/utils/index.js